import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const EnterpriseFooter = () => {
  const navigate = useNavigate();

  const footerSections = [
    {
      title: 'PRODUCT',
      links: [
        { name: 'Features', path: '/features' },
        { name: 'Pricing', path: '/pricing' },
        { name: 'Security', path: '/security' },
        { name: 'Integrations', path: '/integrations-marketplace' },
        { name: 'Roadmap', path: '/roadmap' }
      ]
    },
    {
      title: 'COMPANY',
      links: [
        { name: 'About', path: '/about' },
        { name: 'Careers', path: '/careers' },
        { name: 'Press Kit', path: '/press-kit' },
        { name: 'Contact', path: '/contact' }
      ]
    },
    {
      title: 'RESOURCES',
      links: [
        { name: 'Documentation', path: '/documentation' },
        { name: 'API', path: '/api' },
        { name: 'Community', path: '/community' }
      ]
    },
    {
      title: 'LEGAL',
      links: [
        { name: 'Privacy Policy', path: '/privacy-policy' },
        { name: 'Terms of Service', path: '/terms' },
        { name: 'Cookie Policy', path: '/cookie-policy' },
        { name: 'GDPR Statement', path: '/gdpr' }
      ]
    }
  ];

  return (
    <footer className="bg-[#0B1220] border-t border-white/10 py-16">
      <div className="max-w-7xl mx-auto px-6">
        {/* Footer Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8 mb-12">
          {/* Brand Column */}
          <div className="col-span-2 md:col-span-4 lg:col-span-1">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 bg-[#FFD100] rounded-lg flex items-center justify-center">
                <Icon name="Zap" size={24} color="#0B1220" strokeWidth={2.5} />
              </div>
              <span className="text-xl font-bold text-white">First On Date</span>
            </div>
            <p className="text-white/60 text-sm mb-6">
              The AI-native Employee Success OS transforming onboarding worldwide.
            </p>
            <div className="flex gap-4">
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/5 hover:bg-white/10 rounded-lg flex items-center justify-center transition-all duration-300">
                <Icon name="Twitter" size={18} color="rgba(255,255,255,0.6)" />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/5 hover:bg-white/10 rounded-lg flex items-center justify-center transition-all duration-300">
                <Icon name="Linkedin" size={18} color="rgba(255,255,255,0.6)" />
              </a>
              <a href="https://github.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/5 hover:bg-white/10 rounded-lg flex items-center justify-center transition-all duration-300">
                <Icon name="Github" size={18} color="rgba(255,255,255,0.6)" />
              </a>
            </div>
          </div>

          {/* Link Columns */}
          {footerSections?.map((section, index) => (
            <div key={index}>
              <h4 className="text-white/80 font-bold text-sm mb-4 uppercase tracking-wider">{section?.title}</h4>
              <ul className="space-y-3">
                {section?.links?.map((link, idx) => (
                  <li key={idx}>
                    <button
                      onClick={() => navigate(link?.path)}
                      className="text-white/60 hover:text-[#FFD100] text-sm transition-colors duration-300">
                      {link?.name}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/40 text-sm">
            © 2024 First On Date. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <div className="flex items-center gap-2">
              <Icon name="Shield" size={16} color="#10B981" />
              <span className="text-emerald-400 text-sm font-semibold">SOC2 Compliant</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="Lock" size={16} color="#10B981" />
              <span className="text-emerald-400 text-sm font-semibold">GDPR Ready</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default EnterpriseFooter;